import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm } from "react-hook-form";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import ButtonAction from "/src/components/UI/Button/Button";
import StatementBlock from "./StatementBlock";
import "./StatementModal.css"
import "/src/assets/css/polices.css";
import { configureRowStatement } from "../../../configureRowStatement";
import statementService from "../../../services/statementService";
import useRegex from "../../hooks/useRegex";

const WorksheetModalBody = ({ data, title, dataset }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    const { addStatement, updateStatement } = statementService

    const {regex} = useRegex();

    let defaultValues = data;
    for (let key in defaultValues) {
        if (Array.isArray(defaultValues[key]) == false) continue;
        defaultValues[key] = data[key].map(name => ({ name })); // on passe de :  ['toto' ...] -> [{name : 'toto'}] 
    }

    const { register, setError, clearErrors, handleSubmit, control, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: defaultValues

    });
    var registerObject = {
        register: register,
        setError: setError,
        clearErrors: clearErrors,
        control: control,
        setValue: setValue
    }
    const onSubmit = async () => {
        let dataToSend = getValues()
        if (data) {
            delete dataToSend.timestamp;
            delete dataToSend.id
        }
        for (let column of dataset.columns) {
            if (column.type != "text") continue;
            dataToSend = configureRowStatement(dataToSend, column.id, "value")
        }
        let [response, error] = data ? await updateStatement(dataset.name, data.id, { "data": dataToSend }) : await addStatement(dataset.name, { "data": dataToSend })
        if (error !== null) {
            console.log(error);
            return;
        }
        dataToSend.id = data ? data.id : response._id
        modal.resolve(dataToSend)
        onClose();
        return;
    };


    return (
        <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
            <Form.Title>{title}</Form.Title>
            <Form.Body className="body-editModal-container">
                <br />
                {
                    dataset.columns.map((item, index) => {
                        let isDate = item.type == "date";
                        let obj = data ? data[item.id] : null;
                        return (
                            <>
                                {index > 0 && <div className="statement-modal-bar" />}
                                <div className={"statement-container " + (isDate ? "statement-container-date" : "")}>
                                    <Field listClassName={"statement_label_field " + (isDate ? "statement_label_field_date" : "")} label={item.name} />
                                    <StatementBlock data={obj} column={item} setValue={setValue} registerObject={registerObject} />
                                </div>
                            </>
                        )
                    })
                }
            </Form.Body>
            <Form.Buttons>
                {
                    dataset.columns.length > 0 &&
                    <ButtonAction type="button" label={data ? "Update" : "Add"} disabled={Object.keys(errors).length == 0 ? (getValues().label != "" ? false : true) : true} onClick={onSubmit}></ButtonAction>

                }
            </Form.Buttons>
            <br />
        </Form>
    )
};

export default WorksheetModalBody;